import React from 'react';
import { zeroPadding } from '@bydesign-ui/utils';
export function Time(props) {
  var date = props.date;
  return React.createElement("span", null, [date.getHours(), date.getMinutes(), date.getSeconds()].map(function (i) {
    return zeroPadding(i, 2);
  }).join(':'));
}